import React, { type FC } from 'react';

import { CheckIcon } from '@/common/check-icon';
import { UncheckIcon } from '@/common/uncheck-icon';

export interface CheckBoxProps {
    checked: boolean;
    className?: string;
    label: string;
    description?: string;
    onChange: (checked: boolean) => void;
}

export const CheckBox: FC<CheckBoxProps> = ({ checked, className, description, label, onChange }) => {
    const iconSize = 22;

    return (
        <div className={`flex flex-row items-start gap-2 ${className || ''}`} aria-checked={checked}>
            <div className="cursor-pointer" onClick={() => onChange(!checked)} onKeyDown={() => onChange(!checked)}>
                {checked ? <CheckIcon size={iconSize} title={label} /> : <UncheckIcon size={iconSize} title={label} />}
            </div>
            <div className="flex flex-col w-full item">
                <p className="text-sm text-white">{label}</p>
                {description && <p className="text-xs text-gray-110 mt-1">{description}</p>}
            </div>
        </div>
    );
};
